import { createLazyFileRoute } from "@tanstack/react-router";

import { AuthPage } from "@/features/admin/routes/AuthProviders";

export const Route = createLazyFileRoute("/_auth/admin/auth/")({
  component: AuthPage,
});
